module.exports = __webpack_public_path__ + "static/media/lk.c011f704.jpeg";